import React from "react";
import {Trans, useTranslation} from "react-i18next";
import {Button, ButtonStyles} from "../form/Button/Button";
import Modal from "./Modal";
import {VoucherType} from "../../../typescript-library";

interface IApplicableVouchersProps {
  closeFunction: () => void;
  isVisible: boolean;
  voucherTitle: string;
  voucherType: VoucherType | null;
}

const ApplicableVouchersModal: React.FC<IApplicableVouchersProps> = (props) => {
  const {t} = useTranslation();
  const voucherConditionsTransKey =
    prohibitVouchersForDiscountedItems && props.voucherType === "Relative"
      ? "general.voucherRedemptionConditionsExtended"
      : "general.voucherRedemptionConditions";

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <h2>{props.voucherTitle}</h2>
      <p>
        {t("general.pleaseNote") + ": "}
        <Trans
          i18nKey={voucherConditionsTransKey}
          ns="translations"
          components={{
            a: <a href={t("url.voucherActionsLink")} target="_blank" rel="noreferrer" />,
          }}
        />
      </p>
      <p>{t("general.voucherCategoryRestriction")}</p>
      <p>{t("general.voucherCannotBeCombined")}</p>
      <p>{t("general.voucherCannotBePublished")}</p>
      <div className="center">
        <Button styles={[ButtonStyles.big]} action={props.closeFunction}>
          {t("general.okay")}
        </Button>
      </div>
    </Modal>
  );
};

export default ApplicableVouchersModal;

/* ATTENTION: If there is currently a promotion running, where percentage vouchers are not applicable to
 * discounted items, then change the value here to 'true'. */
export const prohibitVouchersForDiscountedItems = false;
